import styled from "styled-components";
import {useLocation} from "react-router-dom";
import {navigationName} from "./entity";
import {Fragment, useEffect, useState} from "react";
import {topicColor} from "../../assets/GlobalStyles";

function Navigator ({global = false}) {
  const location = useLocation()
  const [depths, setDepths] = useState([])

  useEffect(() => {
    const navigation = navigationName[location.pathname]
    setDepths(
        navigation
            ? navigation.split('/').filter(Boolean)
            : []
    )
  }, [location.pathname]);

  if (depths.length === 0) return null

  const [homeDepth, ...pageDepths] = depths;

  return (
    <NavigatorContainer $global={global} aria-label="현재 페이지 경로">
      <HomeDepth aria-label={homeDepth} title={homeDepth}>
        <svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="m12 3 9 8h-2v10h-5v-6h-4v6H5V11H3l9-8Zm0 2.69L7 10.14V19h1v-6h8v6h1v-8.86l-5-4.45Z"/>
        </svg>
      </HomeDepth>
      {pageDepths.map((depth, index) => (
          <Fragment key={`${depth}-${index}`}>
          <Arrow/>
          <Depth title={depth}>{depth}</Depth>
          </Fragment>
      ))}
    </NavigatorContainer>
  )
}
export default Navigator;

const NavigatorContainer = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  height: ${({$global}) => $global ? '36px' : '20px'};
  margin-bottom: ${({$global}) => $global ? '0' : '20px'};
  overflow: hidden;
  & > div:last-child {
    color: ${topicColor};
    font-weight: bold;
  }
`

const Depth = styled.div`
  margin-right: 9px;
  overflow: hidden;
  color: #7b838c;
  font-size: var(--font-size-13);
  text-overflow: ellipsis;
  white-space: nowrap;
`

const HomeDepth = styled.div`
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  margin-right: 9px;
  border-radius: 6px;
  color: #69727c;

  &:hover {
    background: #f5f6f8;
    color: #f5811f;
  }
`;

const Arrow = styled.div`
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  margin-right: 9px;
  border-top: 1px solid #b7bdc4;
  border-right: 1px solid #b7bdc4;
  transform: rotate(45deg);
`
